export function isModelTypeDescriptionBased(nlpModelProviderType: string): boolean {
  return ['llm-classifier'].includes(nlpModelProviderType as any)
}
